import { combineReducers } from '@reduxjs/toolkit';
import tourneyChampionship from './championship';
import { bracketsSlice, groupsSlice, stagesSlice } from './stages';

const tourneysReducer = combineReducers({
  championship: tourneyChampionship,
  stages: stagesSlice.reducer,
  groups: groupsSlice.reducer,
  brackets: bracketsSlice.reducer,
});

export default tourneysReducer;
